import { Controller } from 'react-hook-form';


const TextFormInput = ({ name, control, label, rules, ...props }) => {
  return (
    <div className="form-group">
      {label && (
        <label className='text-sm text-gray-600' htmlFor={name}>
          {label}
          {rules?.required && <span className="text-danger">*</span>}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <>
            <input
              {...field}
              {...props}
              className={`form-control ${error ? 'is-invalid' : ''} ${props.className || ''}`}
              id={name}
            />
            {error && <div className="text-red-500 text-[12px]">{error.message}</div>}
          </>
        )}
      />
    </div>
  );
};

export default TextFormInput;